import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function userAccountReducer(state = initialState.userAccount, action) {
    switch (action.type) {
        case types.LOAD_HOME_PAGE_TICKETS_DATA_SUCCESS: return {
            ...state,
            isTicketsDataLoadedSuccessful: true,
            loadHomePageTicketsDataErrorMessages: [],
            homePageTicketsData: action.homePageTicketsData

        };
        case types.LOAD_HOME_PAGE_TICKETS_DATA_ERROR: return {
            ...state,
            isTicketsDataLoadedSuccessful: false,
            loadHomePageTicketsDataErrorMessages: action.loadHomePageTicketsDataErrorMessages,
            homePageTicketsData: {}

        };
        case types.RESET_HOME_PAGE_TICKETS_DATA_FORM_STATE: return {
            ...state,
            isTicketsDataLoadedSuccessful: false,
            loadHomePageTicketsDataErrorMessages: [],
            homePageTicketsData: {}
        };
        case types.LOAD_USER_DATA_SUCCESS:
            return {
                ...state,
                userAccountData: action.data.userAccountData,
                isAccountPageRefresh: action.data.isAccountPageRefresh,
                isUserAccountDataLoadedSuccessful: true,
                isUserNotSignedIn: false,
                userAddedToAddressBookSuccessful: false,
                saveUserToAddressBookErrorMessages: []
            };
        case types.LOAD_USER_DATA_ERROR:
            return {
                ...state,
                userAccountData: {},
                isAccountPageRefresh: false,
                isUserNotSignedIn: action.isUserNotSignedIn,
                isUserAccountDataLoadedSuccessful: false
            };
        case types.LOAD_ORDER_HISTORY_SUCCESS:
            return {
                ...state,
                orderHistoryData: action.orderHistoryData,
                isOrderHistoryLoadedSuccessful: true,
                displayCancelledFiles: action.displayCancelledFiles
            };
        case types.LOAD_ORDER_HISTORY_ERROR:
            return {
                ...state,
                orderHistoryData: [],
                isOrderHistoryLoadedSuccessful: false
            };
        case types.LOAD_ORDER_HISTORY_PAGES_SUCCESS: return {
            ...state,
            areOrderHistoryPagesLoadedSuccessful: true,
            orderHistoryPages: action.orderHistoryPages,
            displayCancelledFiles: action.displayCancelledFiles
        };
        case types.LOAD_ORDER_HISTORY_PAGES_ERROR: return {
            ...state,
            areOrderHistoryPagesLoadedSuccessful: false,
            orderHistoryPages: 0
        };
        case types.LOAD_ORDER_DETAILS_SUCCESS: return {
            ...state,
            orderDetails: action.orderDetails,
            areOrderDetailsLoadedSuccessful: true
        };
        case types.LOAD_ORDER_DETAILS_ERROR: return {
            ...state,
            orderDetails: {},
            areOrderDetailsLoadedSuccessful: false
        };
        case types.LOAD_USER_TICKETS_SUCCESS: return {
            ...state,
            userTicketsData: action.userTicketsData,
            hideOldTickets: action.hideOldTickets,
            isUserTicketsDataLoadedSuccessful: true,
        };
        case types.LOAD_USER_TICKETS_ERROR: return {
            ...state,
            userTicketsData: {},
            isUserTicketsDataLoadedSuccessful: false,
        };
        case types.DOWNLOAD_PDF_FILE_SUCCESS: return {
            ...state,
            downloadPdfFileErrorMessages: [],
            isPdfFileDownloadedSuccessful: true
        };
        case types.DOWNLOAD_PDF_FILE_ERROR: return {
            ...state,
            isPdfFileDownloadedSuccessful: false,
            downloadPdfFileErrorMessages: action.downloadPdfFileErrorMessages
        };
        case types.UPDATE_USER_DETAILS_SUCCESS:
            return {
                ...state,
                isUserDetailsUpdatedSuccessful: true,
                updateUserDetailsMessages: action.updateUserDetailsMessages
            };
        case types.UPDATER_USER_EMAIL_SUCCESS:
            return {
                ...state,
                isUserDetailsUpdatedSuccessful: true,
                isUserUpdatingEmail: true,
                updateUserDetailsMessages: action.updateUserDetailsMessages
            };
        case types.UPDATE_USER_DETAILS_ERROR:
            return {
                ...state,
                isUserDetailsUpdatedSuccessful: false,
                updateUserDetailsMessages: action.updateUserDetailsMessages
            };
        case types.REMOVE_USER_ACCOUNT_SUCCESS:
            return {
                ...state,
                isUserAccountRemovedSuccessful: true
            };
        case types.REMOVE_USER_ACCOUNT_ERROR:
            return {
                ...state,
                isUserAccountRemovedSuccessful: false,
                removeUserAccountWithTicketsMessage: action.removeUserAccountWithTicketsMessage
            };
        case types.UPDATE_USER_ADDRESSES_SUCCESS:
            return {
                ...state,
                areUserAddressesUpdatedSuccessful: true,
                updateUserAddressesMessages: action.updateUserAddressesMessages
            };
        case types.UPDATE_USER_ADDRESSES_ERROR:
            return {
                ...state,
                areUserAddressesUpdatedSuccessful: false,
                updateUserAddressesMessages: action.updateUserAddressesMessages
            };
        case types.RESET_USER_ADDRESSES_FORM_STATE:
            return {
                ...state,
                areUserAddressesUpdatedSuccessful: false,
                updateUserAddressesMessages: []
            };
        case types.USER_ADDRESSES_ERROR_MESSAGE: return {
            ...state,
            areUserAddressesUpdatedSuccessful: false,
            updateUserAddressesMessages: action.errorMessages
        };
        case types.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                isUserPasswordChangedSuccessful: true,
                changePasswordMessages: action.changePasswordMessages
            };
        case types.CHANGE_PASSWORD_ERROR:
            return {
                ...state,
                isUserPasswordChangedSuccessful: false,
                changePasswordMessages: action.changePasswordMessages
            };
        case types.RESET_USER_DETAILS_FORM_STATE:
            return {
                ...state,
                isUserDetailsUpdatedSuccessful: false,
                updateUserDetailsMessages: []
            };
        case types.RESET_CHANGE_PASSWORD_FORM_STATE:
            return {
                ...state,
                isUserPasswordChangedSuccessful: false,
                changePasswordMessages: [],
            };
        case types.SAVE_USER_TO_ADDRESS_BOOK_SUCCESS:
            return {
                ...state,
                userAddedToAddressBookSuccessful: true,
                saveUserToAddressBookErrorMessages: []
            };
        case types.SAVE_USER_TO_ADDRESS_BOOK_ERROR_MESSAGE:
            return {
                ...state,
                userAddedToAddressBookSuccessful: false,
                saveUserToAddressBookErrorMessages: action.errorMessages
            };
        case types.TOGGLE_DISPLAY_CANCELLED_FILES:
            return {
                ...state,
                displayCancelledFiles: !state.displayCancelledFiles
            };
        case types.TOGGLE_HIDE_OLD_TICKETS:
            return {
                ...state,
                hideOldTickets: !state.hideOldTickets
            };
        case types.LOAD_REFERRAL_CODE_SUCCESS:
            return {
                ...state,
                referralCode: action.userReferralCodeData || '',
                isReferralCodeLoaded: true
            };
        case types.LOAD_REFERRAL_CODE_ERROR:
            return {
                ...state,
                isReferralCodeLoaded: true
            };
        default:
            return state;
    }
}
